import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=bdb467b0&scoped=true"
import script from "./TabsView.vue?vue&type=script&lang=js"
export * from "./TabsView.vue?vue&type=script&lang=js"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=bdb467b0&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./TabsView.vue?vue&type=style&index=1&id=bdb467b0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb467b0",
  null
  
)

export default component.exports